import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

// ** PiP Window Component **
const PipWindow = ({ pipWindow, children, className = '' }) => {
  const containerEl = useRef(document.createElement('div'));

  useEffect(() => {
    if (className) {
      containerEl.current.className = className;
    }
  }, [className]);

  useEffect(() => {
    // Append the container to the PiP window's body when it mounts
    pipWindow.document.body.appendChild(containerEl.current);
    return () => {
      // Cleanup when closing
      if (pipWindow.document.body.contains(containerEl.current)) {
        pipWindow.document.body.removeChild(containerEl.current);
      }
    };
  }, [pipWindow]);

  return createPortal(children, containerEl.current);
};

export default PipWindow;
